module.exports = __webpack_public_path__ + "static/media/TITAN.7cc78a5f.txt";